// extracted by mini-css-extract-plugin
export default {"rootWrapper":"FOVvBLH2Z5aFi_gYZgDS","root":"so1caRi24_AjzNEAOmdM","content":"z80gzKxo9XbfXJhHx3ZX","withMobileMenu":"yOPKCE4O1gT8oxkQ96WT"};